import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => ({
  title: {
    width: '100%',
    marginLeft: '30px'
  }
}));
